import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from '../../../../utilities/validation';

const getDataFromNode = function (node) {
    const nodeDict = ['title', 'x', 'y', 'width', 'height', 'fontcolor', 'selectable', 'fontstyle', 'bgcolor',
        'fontsize'].reduce(
        (data, key) => {
            return {...data, [key]: node.attr[key]};
        }, {}
    );
    return nodeDict;
};

class FeedbackNode extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node)
        };
    }

    render() {
        const {x = 0, y = 0, width = 0, height = 0, fontstyle = ''
            // val = ''
        } = this.state;

        let fontsize = 'inherit';
        if(!isEmpty(this.state.fontsize)) {
            fontsize = parseInt(parseFloat(this.state.fontsize) * 0.9);
            fontsize = `${fontsize}px`;
        }
        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            fontWeight: fontstyle,
            width: `${width}px`,
            height: `${height}px`,
            wordBreak: 'break-word',
            fontSize: fontsize,
        };

        return (
            <div className="node" style={divStyle} />
        );
    }
}

FeedbackNode.propTypes = {
    node: PropTypes.object.isRequired
};

export default FeedbackNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/feedback-node.js